<template>
  <button
    class="base-button"
    :class="{ 'base-button_success': isSuccess, 'base-button_error': isError }"
    @click="$emit('click')"
    :type="type"
    :disabled="isDisabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    isDisabled: {
      required: false,
      type: Boolean,
      default: false
    },
    type: {
      required: false,
      type: String,
      default: 'button'
    },
    isSuccess: {
      required: false,
      type: Boolean,
      default: false
    },
    isError: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.base-button {
  @include fonts.mo-semi;
  display: block;
  min-width: 158px;
  padding: 10px 40px;
  font-size: 13px;
  color: #000;
  background-color: #fff;
  border: 1px solid #000;
  cursor: pointer;
  &:disabled {
    background-color: colors.$grayef;
    color: colors.$gray99;
    border: 1px solid colors.$gray99;
  }
  &_success {
    color: colors.$blue03;
    border: 1px solid colors.$blue03;
  }
  &_error {
    color: colors.$redff;
    border: 1px solid colors.$redff;
  }
}
</style>